import api from "@/store/api";

const clinicalApi = api.injectEndpoints({
  endpoints: (build) => ({
    getClinicalCareTeam: build.query<CareTeamProvider[], string>({
      query: (patientExternalId: string) =>
        `/clinical-data/family/patients/${patientExternalId}/provider-team-assignments`,
    }),
  }),
});

const { useGetClinicalCareTeamQuery, useLazyGetClinicalCareTeamQuery } =
  clinicalApi;

export { useGetClinicalCareTeamQuery, useLazyGetClinicalCareTeamQuery };
